import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { PostApi } from '../services/CommonService2.js';
import { Styles } from "./styles/serviceBox.js";
import img1 from "../../src/politicalimgeas/Homecards/2.png";
import img2 from "../../src/politicalimgeas/Homecards/1.avif";
import scrollingimg from "../../src/politicalimgeas/cardscrolling/bg1.jpeg";
import scrollingimg1 from "../../src/politicalimgeas/cardscrolling/bg2.jpeg";
import scrollingimg2 from "../../src/politicalimgeas/cardscrolling/bg3.jpeg";
import scrollingimg3 from "../../src/politicalimgeas/cardscrolling/bg4.jpeg";
import scrollingimg4 from "../../src/politicalimgeas/cardscrolling/bg5.jpeg";
import scrollingimg5 from "../../src/politicalimgeas/cardscrolling/bg6.jpg";
import scrollingimg6 from "../../src/politicalimgeas/cardscrolling/bg7.jpg";


function Politicalhome() {

    useEffect(() => {
        getCourses();

    }, [])
    const [courseList, setCourseList] = useState([]);
    const [labels, setLabels] = useState(null);
    const [labels1, setLabels1] = useState(null);
    const [trendingList, settrendingList] = useState([]);
    const [dashboardList, setDashboardList] = useState([])





    const getCourses = async () => {
        const reqparam = {
            pageno: 1,
            query: { status: 'Active' },
            usertype: 'APP',
            tenantid: '',
            // optimize: true,
            userid: ""

        }
        const action = "ITPROGRAMS"


        const ResponseData = await PostApi(reqparam, action);

        // setCourseList(ResponseData.data.filter((ele) => { return ele.showondashboard }));
        // setCourse(ResponseData.data)

        const dashquery = {
            pageno: "-1",
            query: {
                status: 'Active', keyid: { $in: ['1', '2'] }

            },
            ptype: "DASHBOARDLABELS"
        }


        const dashboardResponse = await PostApi(dashquery, 'GETDASHOARDLABEL1');
        console.log("dashboard ?", dashboardResponse.data);
        setDashboardList(dashboardResponse?.data)

        if (dashboardResponse.data.length > 0) {
            const lbdata = dashboardResponse.data.filter(t => t.keyid == '1');
            if (lbdata.length > 0) {

                if (lbdata.length > 0) {
                    setLabels(lbdata[0].name);
                }
                const reqparams = {
                    pageno: 1,
                    query: { status: 'Active', showondashboard: '1' }

                }
                const response = await PostApi(reqparams, 'ITPROGRAMS');
                // console.log("actual dashboard 1", response.data.docs);
                setCourseList(response.data.docs);
            }
            const lbdata1 = dashboardResponse.data.filter(t => t.keyid == '2');
            if (lbdata1.length > 0) {
                setLabels1(lbdata1[0].name);

                const reqparams2 = {
                    pageno: 1,
                    query: { status: 'Active', showondashboard: '2' }

                }
                const response2 = await PostApi(reqparams2, 'ITPROGRAMS');
                settrendingList(response2.data.docs);
            }

        }
    }


    const containerRef = useRef(null);
    const scrollAmount = 220;

    const scrollCards = (direction) => {
        if (containerRef.current) {
            containerRef.current.scrollBy({ left: direction * scrollAmount, behavior: "smooth" });
        }
    };

    return (
        <Styles>

            {/* {courseList && courseList.length > 0 &&  */}
            <section className="why-Visualpath">
                <div className="container">
                    <div class="educational-heading mb-5">
                        <h1>Educational Programs</h1>
                        <p>"Empowering learners with cutting-edge and comprehensive educational programs designed to enhance skills, career-focused training, academic excellence, drive career growth with unparalleled exposure to the latest technologies shaping the future."</p>
                    </div>
                    <div className="row justify-content-center">

                        {/* <div className="col-md-12 mb-5">
                            <h3 className="main-title">{labels}</h3>
                            <p className="description mb-0 px-xl-5">The computer Fundamental program is designed for aspiring students joining graduation<br></br> to choose their career as software engineers</p>
                        </div>
                        <br></br> */}

                        {/* {console.log(courseList, "check course list")} */}

                        <div class="col-md-4 ">
                            <Link to={{ pathname: "/collegescholars" }}>
                                <div class="card flex-row" >
                                    <div class="col-md-4 left">
                                        <img src={img1} class="img-fluid" alt="Course Image" width={'350px'} />
                                    </div>
                                    <div class="col-md-8 right">
                                        <h3 class="card-title">College Scholars</h3>
                                        <p class="card-text">
                                        Empowering you to excel academically and professionally with the latest tech insights. Designed for Btech, Degree, PG students. <strong> Enroll
                                        now </strong>
                                        </p>
                                        <a href="" class="btn rounded-pill " >
                                            View More
                                        </a>
                                    </div>
                                </div>
                            </Link>

                        </div>

                        {dashboardList?.map((ele, inx) => {

                            let imageid = 'https://visualpathedu.com/static/media/4th-year.15b862d606512e3257c0.jpg';
                            if (ele?.image) {
                                imageid = ele.image;
                            } else if (ele?.image_url) {
                                imageid = ele.image_url;
                            }
                            else if (ele?.imageurl) {
                                imageid = ele.imageurl ? ele.imageurl : "";
                            }

                            return (
                                <div class="col-md-4">
                                    {inx <= 5 && <div class="card flex-row" >
                                        <Link to={{ pathname: "/course-list" }}
                                            className="d-flex align-items-center">
                                            <div class="col-md-4 left">
                                                <img src={img2} class="img-fluid" alt="Course Image" />
                                            </div>
                                            <div class="col-md-8 right ">
                                                <h3 class="card-title">{ele.name}</h3>
                                                <p class="card-text">
                                                Start your path to success with personalized learning experiences that equip freshers with the knowledge, latest skills. <strong>Enroll Now.</strong> 
                                                </p>
                                                <a href="" class="btn rounded-pill " >
                                                    View More
                                                </a>
                                            </div>

                                        </Link>

                                    </div>}
                                </div>
                            )
                        })}
                    </div>


                </div>

                {/* <div class="card-scrolling container-fluid">
                    <div class="educational-heading">
                        <h1>Constituency Developments</h1>
                    </div>
                    <h2 class="text-secondary p-2 text-decoration-underline fw-bold text-start my-2">2024-2025</h2>
                    <div class="card-wrapper" ref={containerRef}>
                        <div class="card">
                            <a href="#"><img src={scrollingimg} alt="" /></a>
                        </div>
                        <div class="card">
                            <a href="#"><img src={scrollingimg1} alt="" /></a>
                        </div>
                        <div class="card">
                            <a href="#"><img src={scrollingimg2} alt="" /></a>
                        </div>
                        <div class="card">
                            <a href="#"><img src={scrollingimg3} alt="" /></a>
                        </div>
                        <div class="card">
                            <a href="#"><img src={scrollingimg4} alt="" /></a>
                        </div>
                        <div class="card">
                            <a href="#"><img src={scrollingimg5} alt="" /></a>
                        </div>
                        <div class="card">
                            <a href="#"><img src={scrollingimg6} alt="" /></a>
                        </div>

                    </div>
                    <button class="arrow left" onClick={() => scrollCards(-1)}>&#10094;</button>
                    <button class="arrow right" onClick={() => scrollCards(1)}>&#10095;</button>
                </div> */}
            </section>
            {/* } */}


        </Styles>
    )
}

export default Politicalhome
